import { Scroll } from '../utils/scroll'


export class joannaCta {
    constructor() {

        this.ctaManager();
    }


    ctaManager(){
        console.log('joanna')
        let joannaBlock = document.querySelector('.joanna-block');
        let joannaCta = joannaBlock.querySelector('.cta');

        function _canWatchVideo() {
            return document.body.classList.contains('access-2')
        }
        if (_canWatchVideo()){
            joannaCta.style.display = 'none';
        }

        joannaCta.onclick = function (e) {
            e.preventDefault();
            console.log('you clicked joanna')
            let b = new Scroll();
            b._scrollTo("form")
        }
    }

}
